import {
  IClientBusinessModel,
  IClientBusinessTypeModel,
} from '../Types/ClientModelTypes';
import { collectionMap } from './ModelContext/ModelContext';
import { getTypeTree, findCollection } from './avenyModelUtils';

/** Finds a collection in the static collection map, if you want the dynamic collection map (with changes dependent on kodplan) use ModelContext and findCollection */
export const findCollectionStatic = (collectionName: string) =>
  findCollection(collectionMap, collectionName);

export const findCollectionStaticSafe = (
  collectionName: string,
  errorMessage?: string
): IClientBusinessModel => {
  const collection = findCollectionStatic(collectionName);

  if (!collection) {
    throw new Error(
      errorMessage || `Could not find collection with name: ${collectionName}`
    );
  }

  return collection;
};

export const getTypeTreeStatic = (
  collectionName: string,
  componentName?: string | null
): IClientBusinessTypeModel =>
  getTypeTree(collectionMap, collectionName, componentName);
